exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".warnRemind .handing-all-btn[data-v-426e3dc3]{margin-top:20px;margin-left:20px}.warnRemind .warnRemind-table[data-v-426e3dc3]{margin-top:40px}.warnRemind .case-compare .case-compare-item[data-v-426e3dc3]{margin:10px 0}\n", ""]);

// exports
